import { render, staticRenderFns } from "./MicroarrayElementDetail.vue?vue&type=template&id=f7ca26e4&scoped=true"
import script from "./MicroarrayElementDetail.vue?vue&type=script&lang=js"
export * from "./MicroarrayElementDetail.vue?vue&type=script&lang=js"
import style0 from "./MicroarrayElementDetail.vue?vue&type=style&index=0&id=f7ca26e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ca26e4",
  null
  
)

export default component.exports